var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.309,
    height: 22,
    viewBox: "0 0 23.309 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1223.272 -5257.333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1200.729,5273.483h-.854a3.433,3.433,0,0,0-.443-1.065l.606-.6a.766.766,0,0,0,0-1.083.766.766,0,0,0-1.083,0l-.6.606a3.4,3.4,0,0,0-1.065-.443v-.855a.767.767,0,0,0-.766-.766.766.766,0,0,0-.765.766v.855a3.415,3.415,0,0,0-1.065.442l-.606-.606a.768.768,0,0,0-1.083,0,.769.769,0,0,0,0,1.084l.606.6a3.423,3.423,0,0,0-.443,1.065h-.854a.766.766,0,0,0-.766.766.765.765,0,0,0,.766.765h.854a3.409,3.409,0,0,0,.443,1.066l-.606.6a.767.767,0,0,0,0,1.083.764.764,0,0,0,.541.224.764.764,0,0,0,.541-.224l.606-.606a3.394,3.394,0,0,0,1.065.443v.854a.765.765,0,0,0,.765.766.766.766,0,0,0,.766-.766v-.854a3.45,3.45,0,0,0,1.065-.443l.6.6a.764.764,0,0,0,.542.224.763.763,0,0,0,.541-.224.765.765,0,0,0,0-1.082l-.606-.606a3.4,3.4,0,0,0,.443-1.065h.854a.765.765,0,0,0,.766-.765A.766.766,0,0,0-1200.729,5273.483Zm-4.21,2.68a1.917,1.917,0,0,1-1.914-1.914,1.917,1.917,0,0,1,1.914-1.914,1.917,1.917,0,0,1,1.914,1.914A1.917,1.917,0,0,1-1204.939,5276.163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-1209.522,5271.771v-13.75a.688.688,0,0,0-.688-.688h-12.375a.688.688,0,0,0-.687.688v13.75a.691.691,0,0,0,.176.46l6.188,6.875a.685.685,0,0,0,.511.227.686.686,0,0,0,.511-.227l6.187-6.875A.687.687,0,0,0-1209.522,5271.771Zm-1.375-.264-5.5,6.111-5.5-6.111v-12.8h11Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.46a721dd2f0e14b5b8b48a3d42f7eb10.svg";
export { ForwardRef as ReactComponent };